import DatePicker, { DatePickerSizes } from './components/DatePicker';
import Header from './components/Header';

DatePicker.Header = Header;

export { Header as DatePickerHeader };
export { DatePickerSizes };
export default DatePicker;
